import React from 'react';
import { CourseImage } from 'seduo-ui';
const Example = (props) => (<CourseImage src="https://dummyimage.com/260x175/9fa4a8/fff.png" alt="Card image cap" isFinished/>);
export default Example;
